import { render, staticRenderFns } from "./QLOpzioniServizi.vue?vue&type=template&id=71c9e4e5&scoped=true&"
import script from "./QLOpzioniServizi.vue?vue&type=script&lang=js&"
export * from "./QLOpzioniServizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9e4e5",
  null
  
)

export default component.exports